import React from 'react';

import MoreActionsItem from 'shared/ui/MoreActions/MoreActionsItem';
import Hide from 'shared/ui/icons/General/Hide';
import Show from 'shared/ui/icons/General/Show';

interface IPublishActionLabels {
    hide: string,
    show: string,
}

export const renderPublishAction = (published: boolean, labels: IPublishActionLabels, onToggle: () => void) => (
    published
        ? <MoreActionsItem key="hide" label={labels.hide} icon=<Hide/> onClick={onToggle}/>
        : <MoreActionsItem key="show" label={labels.show} icon=<Show/> onClick={onToggle}/>
);
